import { abortAll, abortBatch, abortItem } from "./abort";

const getAbortEnhancer = () => {
  /**
   * an uploader enhancer function to add abort functionality
   */
  return uploader => {
    //$FlowIssue[incompatible-call]: unsure how to tell Flow this is ok...
    uploader.update({
      abortAll,
      abortBatch,
      abortItem
    });
    return uploader;
  };
};

export default getAbortEnhancer;